import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  DISABLED_THEME,
  getColorsByTheme,
  SICREDI_GREEN_THEME,
  THEME_COLORS,
} from '../../config/MaterialTheme';
import styles from './Tag.scss';
import { getMergedClassNames } from '../../utils/HTMLUtils';

const rootClassName = styles.rootClassName;

class Tag extends Component {
  getThemeName = () => {
    if (this.props.disabled) {
      return DISABLED_THEME;
    }
    return this.props.theme || SICREDI_GREEN_THEME;
  };

  getColors = () => {
    return getColorsByTheme(this.getThemeName());
  };

  render() {
    const themeColors = this.getColors();
    return (
      <div
        className={getMergedClassNames([
          rootClassName,
          this.props.className || '',
        ])}
        style={{
          backgroundColor: themeColors.main,
          color: themeColors.contrastText,
        }}
      >
        {this.props.label.toUpperCase()}
      </div>
    );
  }
}

Tag.propTypes = {
  label: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(THEME_COLORS),
  disabled: PropTypes.bool,
};

export default Tag;
